import React, { useMemo, useState, useEffect } from "react";

import DataTable from "react-data-table-component";
import FilterComponent from "./FilterComponent";
import axios from 'axios'
import { API_BASE_PATH } from "../Api";
import { EyeFill } from "react-bootstrap-icons";

const Table = props => {
    const columns = [
        {
            name: "Cluster Id",
            selector: (row) => row.clusterId,
            sortable: true,
            
        },
        {
            name: "Outlet Code",
            selector: (row) => row.outletCode,
            sortable: true,
            cell: row =>
                (
                    <>

            <a  href={"/recommendations?outletCode="+row.outletCode}><EyeFill color="orange"></EyeFill> {row.outletCode}</a>
                       
                    </>
                ) 
        },
        {
            name: "LoginId",
            selector: (row) => row.loginId,
            sortable: true
        },
        {
            name: "Min",
            selector: (row) => row.minValue,
            sortable: true,
            hide: "md"
        },
        {
            name: "Max",
            selector: (row) => row.maxValue,
            sortable: true,
            hide: "md"
        },
        {
            name: "Capacity",
            selector: (row) => row.outletCapacity,
            sortable: true,
            hide: "md"
        },
        {
            name: "  Buttons  ",
            button: true,
            width: "140px" ,    
            cell: row =>
                (
                    <>
                        <button
                            className="btn btn-primary btn-sm"
                            onClick={() => props.click(row.name,row)}
                            style={{ marginRight: "0px",background:"black",marginRight:"2px"}}
                        >Purchase Basket</button>
                    </>
                ) 
        }
    ];
    const [data, setData] = useState([]);
    const [filterText, setFilterText] = React.useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = React.useState(
        false
    );
    const filteredItems = data;
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    var userInfo = localStorage.getItem("userInfo");
    if (userInfo) {
        userInfo = JSON.parse(userInfo);
    }
    
    const onDataFilter=val=>{
        setFilterText(val);
        fetchUsers(1,val);
    }

    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                onDataFilter("");
            }
        };

        return (
            <FilterComponent
                onFilter={e => onDataFilter(e.target.value)}
                onClear={handleClear}
                filterText={filterText}
            />
        );
    }, [filterText, resetPaginationToggle]);

    const fetchData=async page =>{
        const response = await axios.get(API_BASE_PATH+`/objects/outletClusters?lob=${userInfo.accountId}&page=${page}&count=${10}&resolve=true`);
        setData(response.data);
        let count = totalRows;
        if (count == 0) {
            const tr = await axios.get(API_BASE_PATH+`/objects/outletClusters/count?lob=${userInfo.accountId}&page=${page}&count=${10}&resolve=true`);
            count = tr.data.count;
        }
        // const c=total>0?total:perPage*page+response.data.length;
        setTotalRows(count);
        return response.data;
    }

    const fetchDataOC=async (page,filter) =>{
        const response = await axios.get(API_BASE_PATH+`/objects/outletClusters/outletCode/${filter}?lob=${userInfo.accountId}&page=${page}&count=${10}&resolve=true`);
        setData(response.data);
        let count = response.data.length;
        
        setTotalRows(count);
        return response.data;
    }

    const fetchUsers = async (page,filt) => {
        setLoading(true);
        if(!filt){
            await fetchData(page);
        }else{
            await fetchDataOC(page,filt);
        }
        setPerPage(10);
        setLoading(false);
    };

    const handlePageChange = page => {
        fetchUsers(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        // setLoading(true);
        // const response = await axios.get(`/objects/outletClusters?lob=${userInfo.accountId}&page=${page}&count=${newPerPage}&resolve=true`);
        // setData(response.data.data);
        // setTotalRows(response.data.length+100);
        // //setPerPage(newPerPage);
        // setLoading(false);
    };

    useEffect(() => {
        // alert("Calling")

        fetchUsers(1); // fetch page 1 of users
    }, []);

    return (
        <DataTable
            title=""
            columns={columns}
            data={filteredItems}
            progressPending={loading}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={subHeaderComponent}
        />
    );
};




export default Table;
